export default {"src":"/_next/static/media/FB.e8c09cef.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};